import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_member_assurance_payment",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_7 = { class: "row mb-2" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  key: 0,
  class: "col-md-12 mb-2"
}
const _hoisted_11 = { class: "timeline-content" }
const _hoisted_12 = { class: "d-inline-block w-160" }
const _hoisted_13 = {
  key: 1,
  class: "col-md-12 mb-2"
}
const _hoisted_14 = { class: "timeline-content" }
const _hoisted_15 = { class: "d-inline-block w-160" }
const _hoisted_16 = { class: "actif" }
const _hoisted_17 = {
  key: 2,
  class: "col-md-12 mb-2"
}
const _hoisted_18 = { class: "timeline-content" }
const _hoisted_19 = { class: "d-inline-block w-160" }
const _hoisted_20 = { class: "actif" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = {
  key: 0,
  class: "col-md-12 mb-2"
}
const _hoisted_24 = { class: "timeline-content" }
const _hoisted_25 = { class: "d-inline-block w-160" }
const _hoisted_26 = { class: "actif" }
const _hoisted_27 = {
  key: 1,
  class: "col-md-12 mb-2"
}
const _hoisted_28 = { class: "timeline-content" }
const _hoisted_29 = { class: "d-inline-block w-160" }
const _hoisted_30 = { class: "actif" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_32 = { class: "row mt-2" }
const _hoisted_33 = { class: "col-md-12" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-12" }
const _hoisted_36 = {
  key: 0,
  class: "col-md-12 mb-2 mt-2"
}
const _hoisted_37 = { class: "form__label" }
const _hoisted_38 = { class: "form__label" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_40 = { class: "row mt-3" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "form-group mr-b-0em" }
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_45 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_46 = { class: "form-group mr-b-0em" }
const _hoisted_47 = {
  key: 2,
  class: "col-md-6"
}
const _hoisted_48 = { class: "form-group mr-b-0em" }
const _hoisted_49 = {
  key: 3,
  class: "col-md-6"
}
const _hoisted_50 = { class: "form-group mr-b-0em" }
const _hoisted_51 = { class: "col-md-6" }
const _hoisted_52 = { class: "form-group mr-b-0em" }
const _hoisted_53 = { class: "col-12 text-right" }
const _hoisted_54 = {
  type: "submit",
  class: "btn btn-primary mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_SingleSelect = _resolveComponent("SingleSelect")!
  const _component_date_field = _resolveComponent("date-field")!
  const _component_inputText = _resolveComponent("inputText")!
  const _component_price_input = _resolveComponent("price-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestMemberAssurance)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.i18n.t('views.clients.income.payment.title')), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_member_assurance_payment', 'add'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        (_ctx.requestPayment)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.member?.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createElementVNode("p", _hoisted_11, [
                            _createElementVNode("b", _hoisted_12, _toDisplayString(_ctx.i18n.t("tables.members.name")), 1),
                            _createTextVNode(": " + _toDisplayString(_ctx.member?.name), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.hasPermission('download_contract') && _ctx.member?.contractNumber)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("p", _hoisted_14, [
                            _createElementVNode("b", _hoisted_15, _toDisplayString(_ctx.i18n.t("tables.members.contractNumber")), 1),
                            _createTextVNode(" :"),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.member?.contractNumber), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.member?.matricule)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("p", _hoisted_18, [
                            _createElementVNode("b", _hoisted_19, _toDisplayString(_ctx.i18n.t("tables.members.matricule")), 1),
                            _createTextVNode(": "),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.member?.matricule), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    (_ctx.member?.cin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("p", _hoisted_24, [
                            _createElementVNode("b", _hoisted_25, _toDisplayString(_ctx.i18n.t("tables.members.cin")), 1),
                            _createTextVNode(" :"),
                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.member?.cin), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.member?.tele)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("p", _hoisted_28, [
                            _createElementVNode("b", _hoisted_29, _toDisplayString(_ctx.i18n.t("tables.members.tele")), 1),
                            _createTextVNode(" :"),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.member?.tele), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("form", {
                    class: "forms-sample",
                    onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_SingleSelect, {
                          TextLabel: _ctx.i18n.t('tables.subscription_member.assurance'),
                          trackby: `id`,
                          label: `type`,
                          valueProp: `id`,
                          modelValue: _ctx.requestPayment.assurance_id,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestPayment.assurance_id) = $event)),
                          placeholder: _ctx.i18n.t('tables.subscription_member.assurance'),
                          arrayOptions: _ctx.assurancesList,
                          refs: "assurance_id",
                          v: _ctx.v$.assurance_id
                        }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                      ]),
                      (_ctx.selectedAssurance)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("p", _hoisted_37, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('tables.member_assurances.assurance')) + " : ", 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedAssurance?.type) + " " + _toDisplayString(_ctx.formatDaysToPeriod(_ctx.selectedAssurance?.nbDays)), 1)
                            ]),
                            _createElementVNode("p", _hoisted_38, [
                              _createElementVNode("b", null, _toDisplayString(_ctx.i18n.t('tables.member_assurances.total_amount')) + " : ", 1),
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedAssurance?.cost) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_date_field, {
                            modelValue: _ctx.requestPayment.payment.paymentDate,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestPayment.payment.paymentDate) = $event)),
                            label: _ctx.i18n.t('tables.payment.paymentDate'),
                            v: _ctx.v$.payment.paymentDate,
                            disabled: false,
                            fixedDays: 1,
                            isFixedDays: true
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_SingleSelect, {
                          TextLabel: _ctx.i18n.t('tables.payment.paymentMethod'),
                          trackby: `id`,
                          label: `name`,
                          valueProp: `id`,
                          modelValue: _ctx.requestPayment.payment.paymentMethod,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestPayment.payment.paymentMethod) = $event)),
                          placeholder: _ctx.i18n.t('tables.payment.paymentMethod'),
                          arrayOptions: _ctx.payment_methodsList,
                          refs: "paymentMethod",
                          v: _ctx.v$.payment.paymentMethod
                        }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                      ]),
                      (_ctx.requestPayment.payment.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createVNode(_component_SingleSelect, {
                              TextLabel: _ctx.i18n.t('tables.payment.bankName'),
                              trackby: `id`,
                              label: `name`,
                              valueProp: `id`,
                              modelValue: _ctx.requestPayment.payment.bankName,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestPayment.payment.bankName) = $event)),
                              placeholder: _ctx.i18n.t('tables.payment.bankName'),
                              arrayOptions: _ctx.bank_namesList,
                              refs: "bankName",
                              v: _ctx.v$.payment.bankName
                            }, null, 8, ["TextLabel", "modelValue", "placeholder", "arrayOptions", "v"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.requestPayment.payment.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _createVNode(_component_inputText, {
                                modelValue: _ctx.requestPayment.payment.chequeName,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestPayment.payment.chequeName) = $event)),
                                label: _ctx.i18n.t('tables.payment.chequeName'),
                                v: _ctx.v$.payment.chequeName,
                                disabled: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.requestPayment.payment.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _createVNode(_component_inputText, {
                                modelValue: _ctx.requestPayment.payment.chequeNum,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestPayment.payment.chequeNum) = $event)),
                                label: _ctx.i18n.t('tables.payment.chequeNum'),
                                v: _ctx.v$.payment.chequeNum,
                                disabled: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.requestPayment.payment.paymentMethod === 'Chèque bancaire')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _createVNode(_component_date_field, {
                                modelValue: _ctx.requestPayment.payment.dueDate,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestPayment.payment.dueDate) = $event)),
                                label: _ctx.i18n.t('tables.payment.dueDate'),
                                v: _ctx.v$.payment.dueDate,
                                disabled: false,
                                fixedDays: 1,
                                isFixedDays: false
                              }, null, 8, ["modelValue", "label", "v"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_price_input, {
                            modelValue: _ctx.requestPayment.payment.amount_paid,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestPayment.payment.amount_paid) = $event)),
                            label: _ctx.i18n.t('tables.payment.amount_paid'),
                            v: _ctx.v$.payment.amount_paid,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _createElementVNode("button", _hoisted_54, _toDisplayString(_ctx.action == 'add' ? _ctx.i18n.t('button.add') : _ctx.i18n.t('button.edit')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.emptyState())),
                        class: "btn btn-cancel"
                      }, _toDisplayString(_ctx.i18n.t('button.cancel')), 1)
                    ])
                  ], 32)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}